<template>
  <div
    class="relative px-s20 pt-s20 pb-s20 group border border-transparent hover:border-black transition-colors duration-200"
    @click="productClick()">

    <div class="absolute top-s15 left-s15 z-30" v-if="checkForDiscounts()">
      <div class="odd:bg-red even:bg-black rounded-full size-s50 grid place-items-center"
        v-if="item.first_discount > 0">
        <p class="text-white text-t14">-{{ item.first_discount }}%</p>
      </div>
      <div
        class="odd:bg-red even:bg-black rounded-full even:-mt-s15 size-s50 grid place-items-center"
        v-if="item.second_discount > 0">
        <p class="text-white text-t14">-{{ item.second_discount }}%</p>
      </div>
    </div>

    <div class="absolute z-30 text-white top-s15 right-s15 w-fit text-center grid gap-s3"
      v-if="item.stickers.length > 0">
      <div v-for="(item, index) in item.stickers" :key="index" class="py-s3 text-t12 uppercase rounded-md w-s140"
        :class="'sticker-' + item.sticker_color">
        {{ item.title }}
      </div>
    </div>

    <a :href="item.path">
      <div class="grid">
        <img :src="item.thumbnail_medium" @error="onImageError" :alt="item.title"
          class="w-11/12 mx-auto grid-area grid place-items-center" width="300" height="455">
        <img v-if="item.hover" :src="item.hover" :alt="item.title"
          class="grid-area grid place-items-center scale-97 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-150"
          width="300" height="455" loading="lazy">
        <img v-else :src="item.thumbnail_medium" @error="onImageError" :alt="item.title"
          class="grid-area grid place-items-center scale-97 opacity-0 group-hover:scale-100 group-hover:opacity-100 transition-all duration-150"
          width="300" height="455" loading="lazy">
      </div>
    </a>

    <div class="relative bg-white">
      <div
        class="absolute top-s35 left-0 w-full p-s5 bg-white border-t border-light-gray flex items-center justify-between group-hover:top-[-40px] transition-all duration-300">
        <add-to-wishlist :product-id="item.id" :category="true" :product="item">
        </add-to-wishlist>
        <button type="button" class="text-gold flex items-center gap-s5 hover:text-black transition-colors duration-200"
          @click="showQuickView">
          <p class="text-t14 text-black">Brzi pregled</p>
          <magnify-icon svgClassName="size-s25"></magnify-icon>
        </button>
      </div>

      <div
        class="text-center bg-white px-s5 relative pt-s20 border-t border-transparent group-hover:border-light-gray m_1200:px-s20">
        <p class="font-semibold uppercase">{{ item.brend.title }}</p>
        <p class="max-h-s20 overflow-hidden"><a :href="item.path">{{ item.title }}</a></p>
        <div class="mt-s20 mx-auto min-h-s45 grid items-end">
          <p v-if="checkForDiscounts()" class="text-dark-gray line-through">{{ formatPrice(item.price_outlet) }} RSD</p>
          <p class="text-t20 font-medium" :class="checkForDiscounts() ? 'text-red' : 'text-black'">{{
            formatPrice(item.finalPrice) }} RSD</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import accounting from 'accounting';
import MagnifyIcon from "../svg/MagnifyIcon.vue";

export default {
  name: "CategoryProduct",
  components: {
    MagnifyIcon
  },

  props: [
    'item',
    'index'
  ],

  methods: {
    showQuickView() {
      this.$parent._data.showQuickView = true;
      this.$parent._data.item = this.item;
      this.$nextTick(() => {
        document.querySelector('.quick_view_content').classList.add('active_quick_view');
      });
    },

    formatPrice(value) {
      return accounting.formatMoney(value, '', 2, '.', ',')
    },

    productClick() {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_item',
        ecommerce: {
          items: [{
            item_name: this.item.title,
	          item_id: this.item.movem_id,
            price: this.item.final_price,
            item_brand: this.item.brend.title,
            item_category: this.getCategoriesForFeed(),
            index: this.index,
            quantity: '1'
          }]
        }
      });
    },

    getCategoriesForFeed() {
      if (this.item.categories_for_feed) {
        this.item.categories_for_feed.forEach(function (value, i) {
          'item_category' + (i + 1) + ':' + value;
        })
      } else {
        'item_category:' + this.item.categories[3];
      }
    },

	  onImageError(event) {
		  // Replace the src with the placeholder if there's an error
		  event.target.src = '/images/Movem_1200x1820.png';
	  },

	  checkForDiscounts() {
			return this.item.first_discount > 0 || this.item.second_discount > 0;
	  }

  },
}
</script>